module.exports = __webpack_public_path__ + "static/media/pay-white.2dc54b52.svg";